import Table, { dateCell } from "components/table";
import React from "react";
import { connect } from "react-redux";
import { activeMortalityAssessmentSelector } from "../../../../reducers";
import { Card, Form } from "react-bootstrap";
import Collapsible from "../../../../components/forms/Collapsible";

const MortalityAssessmentCurveNumericTable = ({ mortalityAssessmentInfo, ...props }) => {
  const baseData = mortalityAssessmentInfo?.curve_data || [];
  let survivalData = [];
  baseData.forEach(row => {
    if (survivalData === []) {
      survivalData.push({
        year: row.duration,
        starting_lives: row.bom_lives * 1000,
        ending_lives: row.eom_lives * 1000,
      });
    } else if (survivalData.some(element => element.year === row.duration)) {
      const index = survivalData.findIndex(element => element.year === row.duration);
      if (index) survivalData[index].ending_lives = row.eom_lives * 1000;
    } else {
      survivalData.push({
        year: row.duration,
        starting_lives: row.bom_lives * 1000,
        ending_lives: row.eom_lives * 1000,
      });
    }
  });
  survivalData = survivalData.map(row => ({
    deaths: (Number(row.starting_lives) - Number(row.ending_lives)).toFixed(2),
    starting_lives: row.starting_lives.toFixed(2),
    ending_lives: row.ending_lives.toFixed(2),
    year: row.year,
  }));
  const columns = [
    {
      Header: "Date",
      accessor: "date",
      Cell: dateCell,
    },
    {
      Header: "Age",
      accessor: "age",
    },
    {
      Header: "Month",
      accessor: "month",
    },
    {
      Header: "Duration",
      accessor: "duration",
    },
    {
      Header: "Mortality Rating",
      accessor: "mortality_multiplier",
    },
    {
      Header: "qX",
      accessor: "qx",
    },
    {
      Header: "BOM Lives",
      accessor: "bom_lives",
    },
    {
      Header: "Monthly Mortality",
      accessor: "monthly_mortality",
    },
    {
      Header: "Monthly Deaths",
      accessor: "monthly_deaths",
    },
    {
      Header: "EOM Lives",
      accessor: "eom_lives",
    },
  ];

  const survivalColumns = [
    {
      Header: "Year",
      accessor: "year",
    },
    {
      Header: "Starting Lives",
      accessor: "starting_lives",
    },
    {
      Header: "Ending Lives",
      accessor: "ending_lives",
    },
    {
      Header: "Deaths",
      accessor: "deaths",
    },
  ];

  return (
    <Card>
      <Card.Body>
        <Form>
          <Collapsible title="Mortality Assessment Table" initiallyHidden={true} darker={true}>
            <Table
              columns={columns}
              data={baseData}
              defaultSort={true}
              paginated={false}
              emptyMessage="No Data found"
            />
          </Collapsible>
        </Form>
      </Card.Body>
      <Card.Body>
        <Form>
          <Collapsible title="Survival Table">
            <Table
              columns={survivalColumns}
              data={survivalData}
              defaultSort={true}
              paginated={false}
              emptyMessage="No Data found"
            />
          </Collapsible>
        </Form>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = state => {
  return {
    mortalityAssessmentInfo: activeMortalityAssessmentSelector(state),
  };
};

export default connect(mapStateToProps, {})(MortalityAssessmentCurveNumericTable);
